import { useI18n } from "@/lib/i18n";
import { verfahrenLabels } from "@/lib/translations";

const items = [
  "Verzinken", "Zink-Nickel", "Trommelverzinken", "Zink-Mangan-Phosphatieren",
  "CNS-Beizen", "CNS-Elektropolieren", "Schleifen · Bürsten",
  "Brünieren", "Vergolden", "Chemisch-Nickel", "Galvanisch-Nickel",
];

export const Marquee = () => {
  const { lang } = useI18n();
  const labels = verfahrenLabels[lang] || verfahrenLabels.de;
  const row = [...items, ...items];
  return (
    <section
      data-testid="marquee-strip"
      className="relative bg-[#0E0E10] border-y border-white/10 py-8 overflow-hidden"
      aria-label={lang === "en" ? "Processes" : lang === "fr" ? "Procédés" : "Verfahren"}
    >
      <div className="flex w-max marquee-track">
        {row.map((it, i) => (
          <div
            key={i}
            className="flex items-center gap-10 px-10 whitespace-nowrap text-zinc-400"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-white/30" />
            <span className="font-display text-2xl md:text-3xl font-medium tracking-tight">
              {labels[it] || it}
            </span>
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0E0E10] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0E0E10] to-transparent" />
    </section>
  );
};

export default Marquee;
